// src/pages/AGB.js

import React from 'react';
import { Container, Typography, Box, Paper, AppBar, Toolbar, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AccountBalance as AccountBalanceIcon } from '@mui/icons-material';

const AGB = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
      {/* Navigation */}
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#1a365d' }}>
        <Toolbar>
          <Typography 
            variant="h6" 
            sx={{ 
              flexGrow: 1, 
              fontWeight: 700,
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              cursor: 'pointer'
            }}
            onClick={() => navigate('/')}
          >
            <AccountBalanceIcon sx={{ color: '#00bcd4' }} /> Immo-Automation
          </Typography>
          <Button 
            onClick={() => navigate('/')}
            sx={{ color: 'white' }}
          >
            Zurück zur Startseite
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: 8 }}>
        <Paper elevation={0} sx={{ p: 6, borderRadius: 3, border: '2px solid #e2e8f0' }}>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 4, color: '#1a365d' }}>
            Allgemeine Geschäftsbedingungen (AGB)
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              § 1 Geltungsbereich
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge über die Nutzung der 
              Immo-Automation Software zwischen der Immo-Automation GmbH (nachfolgend "Anbieter") und dem 
              Kunden (nachfolgend "Kunde"). Abweichende Bedingungen des Kunden werden nicht anerkannt, es 
              sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              § 2 Vertragsgegenstand
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Der Anbieter stellt dem Kunden eine cloudbasierte Buchhaltungs- und Verwaltungssoftware 
              für Immobilien zur Verfügung. Der Funktionsumfang ergibt sich aus der jeweils gebuchten 
              Leistungsstufe. Der Anbieter ist berechtigt, die Software kontinuierlich weiterzuentwickeln 
              und zu verbessern.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              § 3 Vertragsschluss und Laufzeit
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Der Vertrag kommt durch die Registrierung des Kunden und die anschließende Freischaltung 
              durch den Anbieter zustande. Die Mindestvertragslaufzeit beträgt 12 Monate. Nach Ablauf 
              der Mindestvertragslaufzeit verlängert sich der Vertrag automatisch um jeweils weitere 
              12 Monate, sofern er nicht mit einer Frist von 3 Monaten zum Ende der jeweiligen 
              Vertragslaufzeit gekündigt wird.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              § 4 Vergütung und Zahlung
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Die Vergütung richtet sich nach der jeweils gewählten Leistungsstufe und den aktuellen 
              Preisen auf der Website des Anbieters. Alle Preise verstehen sich zzgl. der gesetzlichen 
              Umsatzsteuer. Die Abrechnung erfolgt monatlich im Voraus. Der Rechnungsbetrag ist 
              innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zur Zahlung fällig.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              § 5 Verfügbarkeit und Wartung
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Der Anbieter bemüht sich um eine Verfügbarkeit der Software von 99% im Jahresmittel. 
              Hiervon ausgenommen sind Wartungsarbeiten sowie Ausfälle, die außerhalb des 
              Einflussbereichs des Anbieters liegen (höhere Gewalt, Verschulden Dritter etc.). 
              Geplante Wartungsarbeiten werden mindestens 48 Stunden im Voraus angekündigt.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              § 6 Datenschutz und Datensicherheit
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Der Anbieter verpflichtet sich, die geltenden Datenschutzbestimmungen einzuhalten. 
              Details ergeben sich aus der Datenschutzerklärung. Der Anbieter erstellt regelmäßig 
              Sicherungskopien der Kundendaten. Der Kunde ist jedoch selbst für die Sicherung seiner 
              Daten verantwortlich und sollte regelmäßig Backups erstellen.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              § 7 Haftung
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für Schäden 
              aus der Verletzung des Lebens, des Körpers oder der Gesundheit. Für leichte Fahrlässigkeit 
              haftet der Anbieter nur bei Verletzung einer wesentlichen Vertragspflicht, deren Erfüllung 
              die ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht und auf deren 
              Einhaltung der Kunde regelmäßig vertrauen darf (Kardinalpflicht).
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              § 8 Kündigung
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Die ordentliche Kündigung ist unter Einhaltung einer Frist von 3 Monaten zum Ende der 
              jeweiligen Vertragslaufzeit möglich. Das Recht zur außerordentlichen Kündigung aus 
              wichtigem Grund bleibt unberührt. Die Kündigung bedarf der Textform (z.B. E-Mail).
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              § 9 Schlussbestimmungen
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. 
              Erfüllungsort und Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Anbieters 
              in Berlin. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, berührt dies die 
              Wirksamkeit der übrigen Bestimmungen nicht.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default AGB;
